define(["exports", "react", "styled-components", "../../atoms", "./Profile", "./Pcd", "./Experience", "./Education", "./Courses", "./Language", "./Preferences", "./Salary", "./Complementary"], function (_exports, _react, _styledComponents, _atoms, _Profile, _Pcd, _Experience, _Education, _Courses, _Language, _Preferences, _Salary, _Complementary) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _Profile = _interopRequireDefault(_Profile);
  _Pcd = _interopRequireDefault(_Pcd);
  _Experience = _interopRequireDefault(_Experience);
  _Education = _interopRequireDefault(_Education);
  _Courses = _interopRequireDefault(_Courses);
  _Language = _interopRequireDefault(_Language);
  _Preferences = _interopRequireDefault(_Preferences);
  _Salary = _interopRequireDefault(_Salary);
  _Complementary = _interopRequireDefault(_Complementary);

  var BoxesInfos = _styledComponents.default.div.withConfig({
    displayName: "CvBody__BoxesInfos",
    componentId: "sc-1kqomsl-0"
  })(["+ div{border-top:solid 1px ", ";margin:24px 0 0;padding:24px 0 0;@media print{margin-top:12px;}}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.lightGray;
  });

  var CvWrapper = _styledComponents.default.div.withConfig({
    displayName: "CvBody__CvWrapper",
    componentId: "sc-1kqomsl-1"
  })(["padding:24px;@media print{orphans:3;page-break-before:always;widows:3;}"]);

  var CvBody = function CvBody(_ref2) {
    var _cvData$pcd, _cvData$pcd$tipo, _cvData$salario_atual, _cvData$salario_atual2, _cvData$pretensao_sal, _cvData$pretensao_sal2;

    var cvData = _ref2.cvData,
        currentLanguage = _ref2.currentLanguage;
    return /*#__PURE__*/_react.default.createElement(CvWrapper, null, /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: cvData == null ? void 0 : cvData.perfil_profissional
    }, /*#__PURE__*/_react.default.createElement(_Profile.default, {
      profile: cvData == null ? void 0 : cvData.perfil_profissional
    })), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: cvData == null ? void 0 : (_cvData$pcd = cvData.pcd) == null ? void 0 : (_cvData$pcd$tipo = _cvData$pcd.tipo) == null ? void 0 : _cvData$pcd$tipo.length
    }, /*#__PURE__*/_react.default.createElement(BoxesInfos, null, /*#__PURE__*/_react.default.createElement(_Pcd.default, {
      pcd: cvData == null ? void 0 : cvData.pcd,
      currentLanguage: currentLanguage
    }))), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: cvData == null ? void 0 : cvData.experiencias
    }, /*#__PURE__*/_react.default.createElement(BoxesInfos, null, /*#__PURE__*/_react.default.createElement(_Experience.default, {
      objective: cvData == null ? void 0 : cvData.objetivo_profissional,
      experiencias: cvData == null ? void 0 : cvData.experiencias
    }))), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: cvData == null ? void 0 : cvData.formacao_academica
    }, /*#__PURE__*/_react.default.createElement(BoxesInfos, null, /*#__PURE__*/_react.default.createElement(_Education.default, {
      level: cvData == null ? void 0 : cvData.nivel_de_escolaridade,
      educationList: cvData == null ? void 0 : cvData.formacao_academica
    }))), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: cvData == null ? void 0 : cvData.cursos_complementares
    }, /*#__PURE__*/_react.default.createElement(BoxesInfos, null, /*#__PURE__*/_react.default.createElement(_Courses.default // professionalId={cvData.profissional_id} //TO DO
    , {
      courses: cvData == null ? void 0 : cvData.cursos_complementares
    }))), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: cvData == null ? void 0 : cvData.idiomas
    }, /*#__PURE__*/_react.default.createElement(BoxesInfos, null, /*#__PURE__*/_react.default.createElement(_Language.default, {
      languages: cvData == null ? void 0 : cvData.idiomas
    }))), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: (cvData == null ? void 0 : cvData.regiao_de_interesse) || (cvData == null ? void 0 : cvData.disponibilidade_viagem) || (cvData == null ? void 0 : cvData.disponibilidade_mudanca)
    }, /*#__PURE__*/_react.default.createElement(BoxesInfos, null, /*#__PURE__*/_react.default.createElement(_Preferences.default, {
      change: cvData == null ? void 0 : cvData.disponibilidade_mudanca,
      travel: cvData == null ? void 0 : cvData.disponibilidade_viagem,
      local: cvData == null ? void 0 : cvData.regiao_de_interesse
    }))), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: (cvData == null ? void 0 : cvData.outros_beneficios) || (cvData == null ? void 0 : cvData.salario_atual)
    }, !!(cvData != null && (_cvData$salario_atual = cvData.salario_atual) != null && _cvData$salario_atual.valor) && (cvData == null ? void 0 : (_cvData$salario_atual2 = cvData.salario_atual) == null ? void 0 : _cvData$salario_atual2.valor) !== 0 || cvData != null && cvData.outros_beneficios || !!(cvData != null && (_cvData$pretensao_sal = cvData.pretensao_salarial) != null && _cvData$pretensao_sal.valor) && (cvData == null ? void 0 : (_cvData$pretensao_sal2 = cvData.pretensao_salarial) == null ? void 0 : _cvData$pretensao_sal2.valor) !== 0 || cvData != null && cvData.outros_beneficios ? /*#__PURE__*/_react.default.createElement(BoxesInfos, null, /*#__PURE__*/_react.default.createElement(_Salary.default, {
      benefits: cvData == null ? void 0 : cvData.outros_beneficios,
      currentSalary: cvData == null ? void 0 : cvData.salario_atual,
      intendedSalary: cvData == null ? void 0 : cvData.pretensao_salarial,
      professionalId: cvData == null ? void 0 : cvData.profissional_id
    })) : null), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: cvData == null ? void 0 : cvData.informacoes_complementares
    }, /*#__PURE__*/_react.default.createElement(BoxesInfos, null, /*#__PURE__*/_react.default.createElement(_Complementary.default, {
      infos: cvData == null ? void 0 : cvData.informacoes_complementares
    }))));
  };

  CvBody.defaultProps = {
    cvData: {}
  };
  var _default = CvBody;
  _exports.default = _default;
});